import { suppliesCollectionIdFormat } from "@redotech/redo-marketplace-id";
import { FilterGroupSchema } from "@redotech/redo-views-common/advanced-filters/advanced-filter-data";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";
import { SuppliesCollectionSchema } from "./collection";

/**
 * Creates a supplies collection when `id` is omitted, otherwise updates it. The
 * conditions are a filter group over product-family tags/vendor.
 */
export const upsertSuppliesCollection = unaryRpc({
  name: "upsertSuppliesCollection" as const,
  input: z.object({
    id: suppliesCollectionIdFormat.schema.optional(),
    title: z.string().min(1),
    conditionsFilterGroup: FilterGroupSchema,
  }),
  output: z.object({ collection: SuppliesCollectionSchema }),
});
